$(document).ready(function () {
  // Check / uncheck all checkboxes
  $('.check_all').on('click', function () {
    $(this).parents('form').find('input:checkbox').prop('checked', $(this).is(':checked'));
    return;
  });

  // Select mutliple checkboxes
  $('.order_checkbox').on('click', function (e) {
    if (e.shiftKey) {
      const selected_to_id = $(this).attr('id');
      const selected_from_id = $('.order_checkbox:checked').first().attr('id');
      if (selected_from_id && selected_to_id) {
        const selected_from = parseInt(selected_from_id.substring(9));
        const selected_to = parseInt(selected_to_id.substring(9));
        let i = selected_from;
        while (i <= selected_to) {
          $('#checkbox_' + i).prop('checked', true);
          i++;
        }
      }
    }
  });
});
